import { GET_COMMENT,
  PUT_COMMENT,
  DELETE_COMMENT,
  GET_KHUYEN_MAI,
  POST_KHUYEN_MAI,
  UPDATE_KHUYEN_MAI,
  DELETE_KHUYEN_MAI,
  SEARCH_KHUYEN_MAI,
  GET_RESERVE } from '../type'

const initialState = {
  listComment: [],
  listPromotion: [],
  countComment: 0,
  countPromotion: 0,
  listSearchKM: [],
  listReserve: []
}

const comment = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMMENT:
      return {
        ...state,
        listComment: action.data.data,
        countComment: action.data.count
      }
    case PUT_COMMENT:
      return {
        ...state,
        listComment: state.listComment.map(
          (item) => item._id === action.data._id ? item = action.data : item
        )
      }
    case DELETE_COMMENT:
      return {
        ...state,
        listComment: state.listComment.filter(item => item._id !== action.data._id),
        countComment: state.countComment - 1
      }
    case GET_KHUYEN_MAI:
      return {
        ...state,
        listPromotion: action.data.data,
        countPromotion: action.data.count
      }
    case POST_KHUYEN_MAI:
      return {
        ...state,
        listPromotion: [...state.listPromotion, action.data]
      }
    case UPDATE_KHUYEN_MAI:
      return {
        ...state,
        listPromotion: state.listPromotion.map(
          (item) => item._id === action.data._id ? item = action.data : item
        )
      }
    case DELETE_KHUYEN_MAI:
      return {
        ...state,
        listPromotion: state.listPromotion.filter(
          (item) => item._id !== action.data.id 
        )
      }
    case SEARCH_KHUYEN_MAI:
      return {
        ...state,
        listSearchKM: action.data
      }
    case GET_RESERVE:
      return {
        ...state,
        listReserve: action.data
      }
    default:
      return state
  }
}

export default comment